<script lang="ts" setup>
import { CAREER_OUR_AWARDS_ITEMS } from '~/domains/career/main/components/career-main-ourAwards/career-main-ourAwards.consts'
import Marquee from '@/components/Marquee/Marquee.vue'

const { isMobile } = useBSBreakpoints()
</script>

<template>
  <div class="career-main-ourAwards">
    <div class="career-main-ourAwards__container">
      <div class="career-main-ourAwards__title">
        <UiHeader
          :header="$t('career.ourAwards.title') "
          :position="isMobile ? 'center' : 'left'"
          header-size="h5"
          header-size-tablet="h5"
          header-size-mobile="h5"
        />
      </div>

      <div
        class="career-main-ourAwards__marquee"
        role="region"
        :aria-label="$t('career.ourAwards.ariaLabel')"
      >
        <Marquee>
          <div class="career-main-ourAwards__marquee-row">
            <div
              v-for="(award, index) in CAREER_OUR_AWARDS_ITEMS"
              :key="index"
              class="career-main-ourAwards__logo"
            >
              <img
                :src="award.image"
                :alt="award.alt"
              >
            </div>
          </div>
        </Marquee>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.career-main-ourAwards {
  margin: 4.8rem 0;
  padding: 0;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
  }

  &__title {
    padding: 0 2.5rem;
  }

  &__marquee {
    width: 100%;
    margin: 6.4rem 0;
  }

  &__marquee-row {
    display: flex;
    align-items: center;
    gap: 3.2rem;
    padding: 0 1.6rem;
  }

  &__logo {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 20rem;
    height: 10rem;

    img {
      width: auto;
      height: 100%;
      object-fit: contain;
    }
  }

  @include atXS {
    &__container {
      padding: 6.4rem 0 0;
    }
  }

  @include atM {
    &__marquee {
      margin-top: 6.4rem;
    }
  }
}
</style>

